<div class="modal-header">
	<h2>{{modalTitles[step-1]}}</h2>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<hr>
<div class="modal-body d-flex align-items-center" style="width: 100%; justify-content: center;">
	<div id="name" class="full-modal" *ngIf="step==1 && !loading">
		<form [formGroup]="contactInfo">
			<div class="row">
				<div class="col-6">
					<h3 class="labels">First Name</h3>
					<input type="text" placeholder="First Name" class="form-control" formControlName="first_name"
						[ngClass]="{'is-valid': contactInfo.get('first_name')?.touched && validateField('first_name'),
										  'is-invalid': contactInfo.get('first_name')?.touched && !validateField('first_name')}" />
				</div>
				<div class="col-6">
					<h3 class="labels">Last Name</h3>
					<input type="text" placeholder="Last Name" class="form-control" formControlName="last_name"
						[ngClass]="{'is-valid': contactInfo.get('last_name')?.touched && validateField('last_name'),
										  'is-invalid': contactInfo.get('last_name')?.touched && !validateField('last_name')}" />
				</div>
			</div>
			<br>
			<div class="row">
				<div class="col-12">
					<h3 class="labels">Company Name</h3>
					<input type="text" id="company_name" placeholder="Company Name" class="form-control"
						formControlName="company_name" [ngClass]="{'is-valid': contactInfo.get('company_name')?.touched && validateField('company_name'),
										  'is-invalid': contactInfo.get('company_name')?.touched && !validateField('company_name')}" />
				</div>
			</div>
			<br>
			<div class="row">
				<div class="col-7">
					<h3 class="labels">Email</h3>
					<input type="email" id="email1" placeholder="Email 1" class="form-control" formControlName="email1"
						[ngClass]="{'is-valid': contactInfo.get('email1')?.touched && validateField('email1'),
										  'is-invalid': contactInfo.get('email1')?.touched && !validateField('email1')}" />
				</div>

				<div class="col-5">
					<h3 class="labels">Mobile Phone</h3>
					<input type="tel" id="mobile_phone" placeholder="Mobile Phone" class="form-control"
						formControlName="mobile_phone" maxlength="10" [ngClass]="{'is-valid': otherContactInfo.get('mobile_phone')?.touched && otherContactInfo.get('mobile_phone')?.valid,
									'is-invalid': otherContactInfo.get('mobile_phone')?.touched && otherContactInfo.get('mobile_phone')?.invalid}"
						(input)="utils.inputSanitizeNumber($event)" />
				</div>

			</div>
		</form>

	</div>

	<div id="contact" class="full-modal" *ngIf="step==2 && !loading">
		<form [formGroup]="otherContactInfo">
			<div class="row">
				<div class="col-6">
					<h3 class="labels">Email 2</h3>
					<input type="email" id="email2" placeholder="Email 2" class="form-control" formControlName="email2"
						[ngClass]="{'is-valid': otherContactInfo.get('email2')?.touched && otherContactInfo.get('email2')?.valid,
									'is-invalid': otherContactInfo.get('email2')?.touched && otherContactInfo.get('email2')?.invalid}" />
				</div>
				<div class="col-6">
					<h3 class="labels">Email 3</h3>
					<input type="email" id="email3" placeholder="Email 3" class="form-control" formControlName="email3"
						[ngClass]="{'is-valid': otherContactInfo.get('email3')?.touched && otherContactInfo.get('email3')?.valid,
									'is-invalid': otherContactInfo.get('email3')?.touched && otherContactInfo.get('email3')?.invalid}" />
				</div>
			</div>
			<br>
			<br>
			<div class="row">

				<div class="col-4">
					<h3 class="labels">Phone Home</h3>
					<input type="tel" id="phone_home" placeholder="Phone Home" class="form-control"
						formControlName="phone_home" maxlength="10" [ngClass]="{'is-valid': otherContactInfo.get('phone_home')?.touched && otherContactInfo.get('phone_home')?.valid,
									'is-invalid': otherContactInfo.get('phone_home')?.touched && otherContactInfo.get('phone_home')?.invalid}"
						(input)="utils.inputSanitizeNumber($event)" />
				</div>
				<div class="col-4">
					<h3 class="labels">Phone Work</h3>
					<input type="tel" id="phone_work" placeholder="Phone Work" class="form-control"
						formControlName="phone_work" maxlength="10" [ngClass]="{'is-valid': otherContactInfo.get('phone_work')?.touched && otherContactInfo.get('phone_work')?.valid,
									'is-invalid': otherContactInfo.get('phone_work')?.touched && otherContactInfo.get('phone_work')?.invalid}"
						(input)="utils.inputSanitizeNumber($event)" />
				</div>
				<div class="col-4">
					<h3 class="labels">Phone Other</h3>
					<input type="tel" id="phone_other" placeholder="Phone Other" class="form-control"
						formControlName="phone_other" maxlength="10" [ngClass]="{'is-valid': otherContactInfo.get('phone_other')?.touched && otherContactInfo.get('phone_other')?.valid,
									'is-invalid': otherContactInfo.get('phone_other')?.touched && otherContactInfo.get('phone_other')?.invalid}"
						(input)="utils.inputSanitizeNumber($event)" />
				</div>
			</div>
		</form>
	</div>

	<div id="Location" class="full-modal" *ngIf="step==3 && !loading">

		<form [formGroup]="locationInfo">
			<div class="row">
				<div class="col-6">
					<h3 class="labels">Address</h3>
					<input type="text" id="address" placeholder="Address" class="form-control"
						formControlName="address" [ngClass]="{'is-valid': locationInfo.get('address')?.touched && locationInfo.get('address')?.valid,
									'is-invalid': locationInfo.get('address')?.touched && locationInfo.get('address')?.invalid}" />
				</div>
				<div class="col-6">
					<h3 class="labels">Timezone</h3>
					<select id="timezone" class="form-control" formControlName="timezone" [ngClass]="{'is-valid': locationInfo.get('timezone')?.touched && locationInfo.get('timezone')?.valid,
													'is-invalid': locationInfo.get('timezone')?.touched && locationInfo.get('timezone')?.invalid}">
						<option value="" disabled selected>Select your Timezone</option>
						<option *ngFor="let timezone of timezones" [value]="timezone.shortName">{{ timezone.name }}</option>
					</select>
				</div>
			</div>
			<br>
			<div class="row">
				<div class="col-4">
					<h3 class="labels">City</h3>
					<input type="text" id="city" placeholder="City" class="form-control" formControlName="city"
						[ngClass]="{'is-valid': locationInfo.get('city')?.touched && locationInfo.get('city')?.valid,
									'is-invalid': locationInfo.get('city')?.touched && locationInfo.get('city')?.invalid}" />
				</div>
				<div class="col-4">
					<h3 class="labels">State</h3>
					<select id="state" class="form-control" formControlName="state" [ngClass]="{'is-valid': locationInfo.get('state')?.touched && locationInfo.get('state')?.valid,
									'is-invalid': locationInfo.get('state')?.touched && locationInfo.get('state')?.invalid}">
						<option value="" disabled selected>Select your State</option>
						<option *ngFor="let state of states" [value]="state.shortName">{{ state.name }}</option>
					</select>
				</div>
				<div class="col-4">
					<h3 class="labels">Zip Code</h3>
					<input type="tel" id="zip_code" placeholder="Zip Code" class="form-control"
						formControlName="zip_code" maxlength="6" [ngClass]="{'is-valid': locationInfo.get('zip_code')?.touched && locationInfo.get('zip_code')?.valid,
									'is-invalid': locationInfo.get('zip_code')?.touched && locationInfo.get('zip_code')?.invalid}"
						(input)="utils.inputSanitizeNumber($event)" />
				</div>
			</div>
		</form>
	</div>

	<div id="Company" class="full-modal" *ngIf="step==4 && !loading">

		<form [formGroup]="lmsInfo">
			<div class="row">
				<div class="col-6">
					<h3 class="labels">Account Associated</h3>
					<select id="account_associated" class="form-control" formControlName="account_associated" [ngClass]="{'is-valid': lmsInfo.get('account_associated')?.touched && lmsInfo.get('account_associated')?.valid,
									'is-invalid': lmsInfo.get('account_associated')?.touched && lmsInfo.get('account_associated')?.invalid}">
						<option value="" disabled selected>Select your Account</option>
						<option *ngFor="let employee of employeeUsers" [value]="employee.login">
							{{ employee.login }}
						</option>
					</select>
				</div>
				<div class="col-6">
					<h3 class="labels">User Type</h3>
					<select id="user_type" class="form-control" formControlName="user_type" [ngClass]="{'is-valid': lmsInfo.get('user_type')?.touched && lmsInfo.get('user_type')?.valid,
									'is-invalid': lmsInfo.get('user_type')?.touched && lmsInfo.get('user_type')?.invalid}">
						<option value="1" selected>Normal User</option>
						<option value="2">Hourly User</option>
					</select>
				</div>
			</div>
			<br>
			<div class="row">
				<div class="col-4"></div>
				<div class="col-4" align="center">
					<div class="form-check form-switch form-switch-lg" dir="ltr" align="center">
						<input type="checkbox" class="form-check-input" [(ngModel)]="linkCampaign"
							(click)="linkCampaignToggle()" [ngModelOptions]="{standalone: true}" />
						<label class="form-check-label" for="customSwitchsizelg">¿Link user to campaign?</label>
					</div>
				</div>
				<div class="col-4"></div>
			</div>
			<div class="row">
				<div class="col-2"></div>
				<div class="col-8" align="center">
					<p class="text-muted" *ngIf="!linkCampaign">If this is deactivated, the user will be created with a new alias. You will then be able to create a new campaign after completing this step.</p>
					<p class="text-muted" *ngIf="linkCampaign">The new user will be linked to the selected campaign through their alias.</p>
				</div>
				<div class="col-2"></div>
			</div>
			<br>
			<div class="row" *ngIf="linkCampaign">
				<div class="col-4"></div>
				<div class="col-4" align="center">
					<h3 class="labels">Alias</h3>
					<input type="text" id="alias" placeholder="Alias" class="form-control" disabled [value]="lmsInfo.get('alias').value"/>
				</div>
				<div class="col-4"></div>
			</div>
			<br>

			<div class="row" *ngIf="linkCampaign">
				<div class="col-3"></div>
				<div class="col-6" align="center">
					<h3 class="labels">Select Campaign</h3>
					<select id="campaign" class="form-control" (change)="onCampaignSelect($event)" formControlName="alias" [ngClass]="{'is-valid': lmsInfo.get('alias')?.touched && lmsInfo.get('alias')?.valid,'is-invalid': lmsInfo.get('alias')?.touched && lmsInfo.get('alias')?.invalid}">
						<option value="" disabled selected>Select your Campaign</option>
						<option *ngFor="let campaign of campaigns" [value]="campaign.alias">{{ campaign.name }}</option>
					</select>
				</div>
				<div class="col-3"></div>
			</div>

		</form>
	</div>
	<div id="Company" class="full-modal d-flex justify-content-center align-items-center" *ngIf="loading">
		<div align="center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Creating new user...</span>
			</div>
			<br>
			<h3 class="loader-text">Creating new user...</h3>
		</div>
	</div>
</div>
<hr>
<div class="modal-footer">
	<div class="container">
		<div class="row">
			<div class="col-6" align="left">
				<button type="button" class="btn btn-outline-secondary waves-effect waves-light" (click)="prev()"
					*ngIf="step != 1" [disabled]="loading"> <i class="bx bx-arrow-back"></i> Back</button>
			</div>
			<div class="col-6" align="right">
				<button type="button" class="btn btn-secondary waves-effect waves-light" (click)="next()"
					*ngIf="step != 4" [disabled]="loading">Next</button>
				<button type="button" class="btn btn-secondary waves-effect waves-light" (click)="validateStep4()"
					*ngIf="step == 4" [disabled]="loading">Create User</button>
			</div>
		</div>
	</div>

</div>
